<template>
  <div class="page-container page-customType">
      <el-form label-position="right"  :model="saveForm" :rules="saveRules" ref="saveForm" label-width="160px">
          <el-form-item label="标识模版编码" prop="idenModelNumber">
              <el-input v-model="saveForm.idenModelNumber"></el-input>
          </el-form-item>
          <el-form-item label="数据模版名称"  prop="modelId">
            <el-select v-model="saveForm.modelId" filterable @change="dataModelChange">
                <el-option v-for="item in dataModuleOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
          </el-form-item>
      </el-form>
      <el-table
        :data="tableData"
        border
        tooltip-effect="dark"
        style="width: 100%;"
       >
        <el-table-column
                prop="nameCh"
                align="center"
                label="中文名称"
        >
        </el-table-column>
        <el-table-column
                prop="minLength"
                align="center"
                label="最小长度"
        >
        </el-table-column>
        <el-table-column
                prop="maxLength"
                align="center"
                label="最大长度"
        >
        </el-table-column>
        <el-table-column label="动态数据">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.dynamics"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="类型"  width="300px">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.dynaType" v-if="scope.row.dynamics">
              <el-radio-button v-for="(value,key) in dataTypes" :label="key" :key="key">{{value}}</el-radio-button>
            </el-radio-group>

          </template>
        </el-table-column>
        <el-table-column
            prop="value"
            align="center"
            label="默认值"
            width="300px"
        >
            <template slot-scope="scope">
                <template v-if="scope.row.dataType === 4">
                  <el-input type="textarea" v-model="scope.row.value" style="width: 100%"></el-input>
                </template>
                <template v-if="scope.row.dataType === 5">
                    <el-select v-model="scope.row.value" style="width: 380px">
                        <el-option label="是" value="是"></el-option>
                        <el-option label="否" value="否"></el-option>
                    </el-select>
                </template>
                <template v-if="scope.row.dataType === 6">
                    <el-date-picker type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="scope.row.value" style="width: 380px">
                    </el-date-picker>
                </template>
            </template>
        </el-table-column>
      </el-table>
      <div class="saveBox">
          <el-button type="primary" @click="saveAdd">保存</el-button>
      </div>
  </div>
</template>
<script>
import {  fetchDataModelList, fetchDataModelInfo, fetchAddIdenModell, fetchIdenModelInfo } from '@/api/customPage.js';
export default {
    data() {
        return {
          dataTypes: {1:'文本',2: '时间'},
          modelId: '',
          saveForm:{
            idenModelNumber: '',
            modelId: '',
          },
          saveRules: {
            idenModelNumber: [
              { required: true, message: '请输入标识模版编码', trigger: 'blur' },
            ],
            modelId: [
              { required: true, message: '请选择数据模版名称', trigger: ['blur','change'] },
            ],
          },
          typeOptions: [
              {
                  value: 4,
                  label: '字符串'
              },
              {
                  value: 5,
                  label: '单选'
              },
              {
                  value: 6,
                  label: '日期'
              },
          ],
          dataModuleOptions: [],
          tableData: [],
          modeType:null
        };
    },
    created() {
      this.getOptionsData()
    },
    mounted() {
      this.init()
      this.modeType = this.$route.query.modeType
    },
    methods: {
        init() {
            // 编辑回显
            this.modelId = this.$route.query.id
            if(this.modelId) {
                this.saveForm.idenModelNumber = this.$route.query.idenModelNumber

                let params = {
                    id: this.modelId,
                }
                fetchIdenModelInfo(params).then(res => {
                    if(res.code === 200) {
                        this.tableData = res.data.dataList
                    }

                })
            }

        },
        getOptionsData() {
          let params = {
            companyId: JSON.parse(localStorage.getItem('info')).companyId,
            pageNum: 1,
            pageSize: 1000,
          }
          fetchDataModelList(params).then(res => {
            if(res.code === 200) {
              this.dataModuleOptions = res.data.list.map(item => {
                  return {
                      label: item.modelName,
                      value: item.id
                  }
              })
              if(this.$route.query.modelId) {
                //   this.saveForm.modelId = 142
                this.saveForm.modelId = JSON.parse(this.$route.query.modelId)
                // this.dataModelChange(this.saveForm.modelId)
              }
            }
          })
        },
        saveAdd() {
            // 添加或编辑
            this.$refs.saveForm.validate((valid) => {
                if(valid) {
                    console.log(this.$route.query.modeType)
                    let params={}
                    if(this.$route.query.modeType === 'add') { // 添加
                        params = {
                            companyId: JSON.parse(localStorage.getItem('info')).companyId,
                            idenModelNumber: this.saveForm.idenModelNumber,
                            modelId: this.saveForm.modelId,
                            data: JSON.stringify(this.tableData)
                        }
                    }else { // 编辑
                        params = {
                            id: this.modelId,
                            companyId: JSON.parse(localStorage.getItem('info')).companyId,
                            idenModelNumber: this.saveForm.idenModelNumber,
                            modelId: this.saveForm.modelId,
                            data: JSON.stringify(this.tableData)
                        }
                    }
                    fetchAddIdenModell(params).then(res => {
                        if(res.code === 200) {
                            this.$message({
								message: "保存成功",
								type: "success",
							});
                            this.$router.push({path: "/mkc/handleModel"});
                        }else {
                           this.$message({
								message: res.message,
								type: "error",
							});
                        }
                    })
                }
            })
        },
        dataModelChange(val) {
            let params = {
                    dataModelId: val,
                }
            fetchDataModelInfo(params).then(res => {
                if(res.code === 200) {
                    this.tableData = res.data.map(item => {
                        return { ...item, value: ''}
                    })
                    console.log('-----this.tableData---', this.tableData)
                }
            })
        }
    }
}
</script>
<style scoped lang="scss">
.page-container{
  background: #fff;
  padding: 10px;
}
.operations{
            display: flex;
            justify-content: space-between;
            height: 60px;
            align-items: center;
            .operation-btns{
                display: flex;
                div{
                    border-radius: 4px;
                    // background: #B9EBEA;
                    background: #51CDCB;
                    font-size: 14px;
                    line-height: 30px;
                    height: 30px;
                    color: #fff;
                    padding: 0 20px;
                    margin-right: 10px;
                    cursor: pointer;
                }
                .disabled{
                    background: #B9EBEA;
                }
            }
            .search-user{
                display: flex;
                .search-input{
                    height: 30px;
                    margin-right: 10px;
                    .el-input__inner{
                        height: 30px;
                    }
                }
                .search-btn{
                    border-radius: 4px;
                    // background: #B9EBEA;
                    background: #51CDCB;
                    font-size: 14px;
                    line-height: 30px;
                    height: 30px;
                    color: #fff;
                    padding: 0 20px;
                    cursor: pointer;
                }
                .disabled{
                    background: #B9EBEA;
                }
            }
        }

        .saveBox{
            text-align: center;
            padding-top: 20px;
            padding-bottom: 10px;
        }

</style>
